import PermissionsService from '../services/apiRequests/permission.service';
import { usersService } from '../services/apiRequests/users.service';

export default {
    namespaced: true,
    state: {
        userPermissions: {}
    },
    getters: {},
    mutations: {
        setUserPermissions(state, userPermissions) {
            state.userPermissions = userPermissions;
        }
    },
    actions: {
        async getUserPermissions({ commit }) {
            try {
                let response = await PermissionsService.getPermissions();
                const curUser = await usersService.getCurUser();
                const userInfo = await usersService.getUserInfo(curUser.data);
                //console.log(userInfo);
                if (userInfo && userInfo.data && userInfo.data.user_data && userInfo.data.user_data.isas_contract_rid) {
                    response.push('contracts');
                } else if (userInfo && userInfo.data && userInfo.data.user_data && userInfo.data.user_data.isas_ksk_rid) {
                    response.push('ksk');
                }
                //response.push('prescription_form');
                // if (userInfo && userInfo.data && userInfo.data.user_data && (userInfo.data.user_data.isas_contract_rid || userInfo.data.user_data.isas_ksk_rid)){
                //     response.push('documents');
                // }
                // console.log(response);
                commit('setUserPermissions', response);
            } catch (error) {
                //console.log(error);
            }
        }
    }
};
